import React from 'react';

const FillIcon = ({ width = 24, height = 24, color = '#fff' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="7.5"
      stroke="#6f6f6f"
      strokeWidth="1.5"
      fill={color}
    />
  </svg>
);

export default FillIcon;
